import React from "react";
import StoreRecords from "../../components/Store/DashboardTabs/StoreRecords";
import StoreSidebarToggle from "../../components/Store/StoreSidebarToggle";

function StoreRecordsPage() {
  return (
    <main>
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between gap-4 bg-white p-2.5 rounded-[22px] shadow-sm border border-primary-100 mb-2 sticky top-0 z-[100] backdrop-blur-md bg-white/90">
          <div className="flex items-center gap-3">
            <StoreSidebarToggle className="!p-2 bg-primary-50 hover:bg-primary-100 text-primary-700 rounded-xl" />
            <h1 className="text-[16px] font-bold text-primary-900 tracking-tight uppercase px-2">Order Records</h1>
          </div>
          <div className="pr-4">
            <span className="text-[12px] font-bold text-primary-400 italic">Historical Database</span>
          </div>
        </div>
        <StoreRecords />
      </div>
    </main>
  );
}

export default StoreRecordsPage;
